import axios from "axios";
import { getToken } from "./storageService";

const api = axios.create({
  baseURL: "https://web.nutrillion.one/",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
    const token = getToken();

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export const POST_OTP = "/api/auth/send_otp";
export const VERIFY_OTP = "/api/auth/otp_verify";
export const POST_APPOINTMENT = "/api/user_appointments/create";
export const GET_FAQ = "/api/web/faq_get?sortby=createdAt&order=asc";
export const GET_FAQS = "/api/web/faq_get";
export const GET_CERTIFICATES = "/api/web/certificate_get";
export const GET_TESTIMONIALS = "/api/web/testimonial_get?sortby=createdAt&order=asc";
export const GET_TESTIMONIAL = "/api/web/testimonial_get";
export const GET_PRIVACY_POLICY = "/api/web/static_get";
export const GET_INSTRUCTORS = "/api/web/listInstructors";
export const GET_ALL_COURSES = "/api/web/ListAllCourses";
export const GET_COURSE_BY_SLUG = "/api/web/course";

export const sendOtp = async (phone, type) => {
  try {
    const response = await api.post(POST_OTP, {
      phone: phone,
      type: type, 
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyOtp = async (phone, otp) => {
  try {
    const response = await api.post(VERIFY_OTP, {
      phone: phone,  
      otp: otp,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createAppointment = async (appointmentData) => {
  console.log("XYZ:-", appointmentData);
  try {
    const response = await api.post(POST_APPOINTMENT, appointmentData);
    console.log("Nivedita from api:-", response.data)
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchBlogs = async () => {
  try {
    const response = await fetch("https://web.nutrillion.one/api/web/blog_get?sortby=createdAt&order=asc");
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("API Fetch Error:", error);
    return { status: false, data: [] };
  }
};

export const fetchCaseStudies = async () => {
  try {
    const response = await fetch("https://web.nutrillion.one/api/web/case_study_get?sortby=createdAt&order=asc");
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("API Fetch Error:", error);
    return { status: false, data: [] };
  }
};

export const getFAQ = async () => {
  try {
    const response = await api.get(GET_FAQ);
    return response.data; 
  } catch (error) {
    console.error("Error fetching FAQs:", error);
    return { status: false, message: "Failed to fetch FAQs", error: error.message };
  }
};
export const getFAQS = async (type = null) => {
  try {
    const url = type ? `${GET_FAQS}?type=${type}` : GET_FAQS;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching FAQs:", error);
    return { status: false, message: "Failed to fetch FAQs", error: error.message };
  }
};
export const getCertificates = async () => {
  try {
    const response = await api.get(GET_CERTIFICATES);
    return response.data;
  } catch (error) {
    console.error("Error fetching Certificates:", error);
    return { status: false, message: "Failed to fetch Certificates", error: error.message };
  }
};

export const getTestimonials = async () => {
  try {
    const response = await api.get(GET_TESTIMONIALS);
    return response.data;
  } catch (error) {
    console.error("Error fetching testimonials:", error);
    return { status: false, message: "Failed to fetch testimonials", error: error.message };
  }
};

export const getTestimonial = async (type = null) => {
  try {
    const url = type ? `${GET_TESTIMONIAL}?type=${type}` : GET_TESTIMONIAL;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching testimonials:", error);
    return { status: false, message: "Failed to fetch testimonials", error: error.message };
  }
};


export const getPrivacyPolicy = async () => {
  try {
    const response = await api.get(GET_PRIVACY_POLICY);
    return response.data;
  } catch (error) {
    console.error("Error fetching privacy policy:", error);
    return { status: false, message: "Failed to fetch privacy policy", error: error.message };
  }
};

export const getInstructors = async () => {
  try {
    const response = await api.get(GET_INSTRUCTORS);
    return response.data;
  } catch (error) {
    console.error("Error fetching instructors:", error);
    return { status: false, message: "Failed to fetch instructors", error: error.message };
  }
};
export const getAllCourses = async () => {
  try {
    const response = await api.get(GET_ALL_COURSES);
    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    return { success: false, message: "Failed to fetch courses", error: error.message };
  }
};
export const getCourseBySlug = async (slug) => {
  try {
    const response = await api.get(`${GET_COURSE_BY_SLUG}/${slug}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching course:", error);
    return { success: false, message: "Failed to fetch course", error: error.message };
  }
};